// This helper ensures images are properly imported in Vite
// Place this file in src/utils/image-helper.ts

/**
 * Helper function to get the URL for an image in Vite
 * This helps resolve issues with image imports in production builds
 * 
 * @param imagePath The path to the image relative to the assets directory
 * @returns The URL to the image that will work in both development and production
 */
export function getImageUrl(imagePath: string): string {
  // For local development with Vite
  try {
    // Try to import the image using Vite's import.meta.url
    const imageUrl = new URL(`../assets/${imagePath}`, import.meta.url).href;
    return imageUrl;
  } catch (error) {
    console.error(`Error loading image: ${imagePath}`, error);
    // Fallback for production or if import fails
    return `/assets/${imagePath}`;
  }
}

// Example usage:
// import { getImageUrl } from '../utils/image-helper';
// const chatbotImageUrl = getImageUrl('chatbot.png');